import { Navigate, useParams, useSearchParams } from 'react-router-dom'

/** 旧路由兼容：/enterprise/bid-parse/:itemId */
export default function DocLocateLegacyRedirect() {
  const { itemId } = useParams()
  const [searchParams] = useSearchParams()
  const scope = searchParams.get('scope') || 'enterprise'
  return <Navigate to={`/locate/${itemId}?scope=${scope}`} replace />
}
